export const popQueryParam = (url: string, key: string): string => {
    try {
        const updatedUrl = new URL(url);
        updatedUrl.searchParams.delete(key);
        const queryValue = updatedUrl.searchParams.get(key);
        window?.history.replaceState(null, '', updatedUrl);
        return queryValue || '';
    } catch (error) {
        return '';
    }
};

export const addQueryParam = (url: string, paramKey: string, paramValue: string): string => {
    const parsedUrl = new URL(url);
    const searchParams = parsedUrl.searchParams;

    searchParams.set(paramKey, paramValue);
    return `${parsedUrl.origin}${parsedUrl.pathname}?${searchParams.toString()}`;
};
